const resourcesMngt = {
    namespaced: true,
    state : {
        resourceId : ''
    },
    getters: {
        getResourceId (state) {
            return state.resourceId
        }
    },
    mutations: {
        setResourceId (state, payload) {
            state.resourceId = payload
        }
    },
    actions: {
        setResourceId ({commit}, payload) {
            commit('setResourceId', payload)
        }
    }
}

export default resourcesMngt